<template>
	<VCard
		class="pa-6 rounded-lg"
		outlined
	>
		<div class="d-flex align-center justify-space-between">
			<h6 class="text-h6">
				{{ title }}
			</h6>
			<VSimpleCheckbox
				v-model="selected"
				color="primary"
				@click="$emit('change', selected)"
			/>
		</div>
		<p class="text-body-1 mt-4 mb-0">
			{{ description }}
		</p>
	</VCard>
</template>

<script lang="ts">
	import Vue from 'vue';
	import Component, { mixins } from 'vue-class-component';

	const Props = Vue.extend({
		props: {
			value: {
				type: Boolean,
				default: false
			},
			title: {
				type: String,
				required: true
			},
			description: {
				type: String,
				required: true
			}
		}
	});

	const MixinsDeclaration = mixins(Props);

	@Component<SelectableCard>({
		model: {
			prop: 'value',
			event: 'change'
		},
		watch: {
			value(val: boolean) {
				this.selected = val;
			}
		}
	})
	export default class SelectableCard extends MixinsDeclaration {
		selected = false;
	}
</script>
